var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 41,
    viewBox: "0 0 27 41",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 0H1.125C0.495 0 0 0.495 0 1.125V39.375C0 40.005 0.495 40.5 1.125 40.5H25.875C26.505 40.5 27 40.005 27 39.375V1.125C27 0.495 26.505 0 25.875 0ZM24.75 38.25H2.25V2.25H24.75V38.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 36.585H22.5C22.815 36.585 23.085 36.315 23.085 36V27C23.085 26.685 22.815 26.415 22.5 26.415H14.625C14.31 26.415 14.04 26.685 14.04 27V36C14.085 36.315 14.31 36.585 14.625 36.585ZM15.21 27.585H21.96V35.46H15.21V27.585Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 25.335H22.5C22.815 25.335 23.085 25.065 23.085 24.75V15.75C23.085 15.435 22.815 15.165 22.5 15.165H14.625C14.31 15.165 14.04 15.435 14.04 15.75V24.75C14.085 25.065 14.31 25.335 14.625 25.335ZM15.21 16.335H21.96V24.21H15.21V16.335Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 14.085H22.5C22.815 14.085 23.085 13.815 23.085 13.5V4.50004C23.085 4.18504 22.815 3.91504 22.5 3.91504H14.625C14.31 3.91504 14.04 4.18504 14.04 4.50004V13.5C14.085 13.815 14.31 14.085 14.625 14.085ZM15.21 5.08504H21.96V12.96H15.21V5.08504Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49998 36.585H12.375C12.69 36.585 12.96 36.315 12.96 36V27C12.96 26.685 12.69 26.415 12.375 26.415H4.49998C4.18498 26.415 3.91498 26.685 3.91498 27V36C3.95998 36.315 4.18498 36.585 4.49998 36.585ZM5.08498 27.585H11.835V35.46H5.08498V27.585Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49998 25.335H12.375C12.69 25.335 12.96 25.065 12.96 24.75V15.75C12.96 15.435 12.69 15.165 12.375 15.165H4.49998C4.18498 15.165 3.91498 15.435 3.91498 15.75V24.75C3.95998 25.065 4.18498 25.335 4.49998 25.335ZM5.08498 16.335H11.835V24.21H5.08498V16.335Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49998 14.085H12.375C12.69 14.085 12.96 13.815 12.96 13.5V4.50004C12.96 4.18504 12.69 3.91504 12.375 3.91504H4.49998C4.18498 3.91504 3.91498 4.18504 3.91498 4.50004V13.5C3.95998 13.815 4.18498 14.085 4.49998 14.085ZM5.08498 5.08504H11.835V12.96H5.08498V5.08504Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 37.3846,
    y2: 24.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.04,
    y1: 26.415,
    x2: 24.1405,
    y2: 35.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.04,
    y1: 15.165,
    x2: 24.1405,
    y2: 24.1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 14.04,
    y1: 3.91504,
    x2: 24.1405,
    y2: 12.8982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 3.91498,
    y1: 26.415,
    x2: 14.0155,
    y2: 35.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 3.91498,
    y1: 15.165,
    x2: 14.0155,
    y2: 24.1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 3.91498,
    y1: 3.91504,
    x2: 14.0155,
    y2: 12.8982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWindow);
export default __webpack_public_path__ + "static/media/icon-window.555b3ea52cd8628595896bd314585fc8.svg";
export { ForwardRef as ReactComponent };